// src/components/document/DocumentViewer/types.ts

import { QueryObserverResult } from "@tanstack/react-query";

import { Document } from "@/api/rest/models/document";

export interface ViewerProps {
  document: Document;
  onSuccess: () => void;
  onError: (error: Error) => void;
  /** The viewer is still loading after a long wait; the parent offers other ways to open the file. */
  onStillLoading?: () => void;
  className?: string;
}

export interface DocumentViewerProps {
  document: Document;
  buildingId?: number;
  householdId?: number;
  className?: string;
  onSelect?: (url: string, originalName: string) => void;
  allowPreview: boolean;
  allowDelete?: boolean;
  updateHousehold?: () => Promise<QueryObserverResult>;
}

// Utility type guard for document types
export const isPreviewableDocument = (document: Document): boolean => {
  const type = document.fileName.split(".").pop()?.toLowerCase();
  return ["pdf", "doc", "docx", "xls", "xlsx", "png", "jpg", "jpeg", "json"].includes(type ?? "");
};

export const getDocumentType = (document: Document): string => {
  return document.fileName.split(".").pop()?.toLowerCase() ?? "";
};

export const is360Image = (document: Document): boolean => {
  const isImage = ["jpg", "jpeg", "png"].includes(document.fileName.split(".").pop()?.toLowerCase() ?? "");
  const is360Folder = document.folderPath.some((folder) => folder === "360" || folder === "360 pildid");
  return isImage && is360Folder;
};
